import i18next from 'i18next';
/** "Not in yet", "In since 08:14", or "In" where the time is not shown */
export const kioskStatusText = (isSignedIn, signedInSince) => {
    if (!isSignedIn) {
        return i18next.t($ => $.stat.signinSelectChildren.lib.src.translations.json.selection.notInYet);
    }
    return signedInSince === null
        ? i18next.t($ => $.stat.signinSelectChildren.lib.src.translations.json.selection.signedIn)
        : i18next.t($ => $.stat.signinSelectChildren.lib.src.translations.json.selection.signedInSince, {
            time: signedInSince,
        });
};
